import React from 'react'
import PropTypes from 'prop-types'
import uuid from 'react-uuid'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

/* eslint-disable react/no-danger */
function GraphicComposition({ data }) {
  const {
    alignImage,
    image,
    text: { text }
  } = data

  const alignRelativeImage = name => {
    const nameLowerCase = name ? name.toLowerCase() : ''
    if (nameLowerCase === 'center') {
      return 'center'
    }
    if (nameLowerCase === 'left') {
      return 'left'
    }

    return 'right'
  }

  let imageComp
  if (image) {
    imageComp = (
      <GatsbyImage
        image={getImage(image.image)}
        className="image"
        imgClassName={`image ${alignRelativeImage(alignImage)}`}
        alt={image.altText}
        objectFit="scale-down"
      />
    )
  }

  const redSlashes = '<span class="red">////</span>'

  // we will replace '////' with span tags
  const content = text.replace(/\/{4}/g, redSlashes)

  return (
    <section className="graphic">
      {imageComp}
      <div className="text-block">
        <p key={uuid()} dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </section>
  )
}

GraphicComposition.propTypes = {
  data: PropTypes.object.isRequired
}

export default GraphicComposition
